import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ApiRouting } from "@globals/classes/ApiRouting";
import { PageNames } from "@globals/openapi-models/model/pageNames";

export type GoogleCaptchaConfig = { siteKey: string; language: string };

@Injectable({
  providedIn: "root"
})
export class GoogleCaptchaManagerService {
  public static readonly googleCaptchaSiteKey = "6LcJFLYUAAAAACnujYYEikUd0XWkvfZgnkMvmSYs";
  private responseToken: string;

  private readonly http = inject(HttpClient);

  public setResponseToken(responseToken: string) {
    this.responseToken = responseToken;
  }

  /**
   * Calls server for verfiying a Google Captcha user-response-token.
   * @param token Google Captcha user-response-token as returned by the frontend captcha component
   * @returns boolean - true for success and false for... you guessed right
   */
  public validateGoogleCaptchaToken(pageNameId: PageNames) {
    return this.http.get<boolean>(ApiRouting.commonEndpoints.validateGoogleCaptchaToken, {
      params: { token: this.responseToken, pageNameId }
    });
  }
}
